import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if this is a browser extension error we should ignore
    const errorString = error?.toString() || '';
    const isExtensionError = 
      errorString.includes('MetaMask') ||
      errorString.includes('chrome-extension') ||
      errorString.includes('ethereum') ||
      errorString.includes('web3');
    
    if (isExtensionError) {
      console.log('[Alvin\'s Place] Caught and ignored extension error:', errorString);
      return { hasError: false, error: null };
    }
    
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log actual app errors, ignore extension errors
    const errorString = error?.toString() || '';
    if (!errorString.includes('chrome-extension') && !errorString.includes('MetaMask')) {
      console.error('[Alvin\'s Place] Application error:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-b from-cosmos-bg to-cosmos-deep flex items-center justify-center p-6">
          <div className="glass rounded-3xl p-8 max-w-md text-center">
            <h2 className="font-heading text-2xl text-starlight mb-4">
              A disturbance in the Field
            </h2>
            <p className="text-starlight/70 mb-6">
              Something unexpected occurred. The Field invites you to try again.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-etheric/30 hover:bg-etheric/50 rounded-full text-starlight transition-all"
            >
              Return to the Field
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
